/** An opt-in, device-local preference, deliberately independent of the account. */
const SOUND_KEY = "aegae.dropSound.v1";
export function getDropSound(): boolean { return localStorage.getItem(SOUND_KEY) === "on"; }
export function setDropSound(enabled: boolean): void { localStorage.setItem(SOUND_KEY, enabled ? "on" : "off"); }
export function playDropSound(): void {
  if (!getDropSound()) return;
  void new Audio("/sounds/drop.m4a").play().catch((cause: unknown) => { console.warn("Drop sound failed:", cause); });
}
